import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';

interface ReusableTableProps {
    columns: string[];
    data?: any[]|null;
    renderRow: (row: any) => React.ReactNode;
    noDataMessage?: string;
}


const ReusableTable: React.FC<ReusableTableProps> = ({ columns, data, renderRow, noDataMessage = 'No data found...' }) => {
    if (data === undefined || data === null) return null;


    return (
        <>
            {data.length > 40 && <span style={{ marginLeft: '10px', color: 'silver' }}>Top 50 records only</span>}
            {data.length === 0 && <span style={{ marginLeft: '10px', color: 'silver' }}>{noDataMessage}</span>}
            {data.length > 0 && (
                <Paper>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {columns.map((column, index) => (
                                        <TableCell key={index}>{column}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row, index) => (
                                    <TableRow key={index} hover>
                                        {renderRow(row)}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}
      
        </>
    );
};

export default ReusableTable;